<template>
  <div>
    <NotificationBar v-if="!hasActiveSubscription">
      <NotificationBarTitle>No base subscription active</NotificationBarTitle>
      Your account has no active base subscription.
      <span v-if="!userHasReadPermission(PermissionTypes.AdminPermissionTypes.billing)">Contact the account manager to purchase or renew the subscription.</span>
      <router-link to="/admin/billing" v-if="userHasReadPermission(PermissionTypes.AdminPermissionTypes.billing)">View Account</router-link>
    </NotificationBar>

    <NotificationBar v-if="displaySubscriptionExpiryWarning">
      <NotificationBarTitle>Subscription Expiring Soon</NotificationBarTitle>
      Your account&apos;s subscription will expire on {{subscriptionExpiryDate | formatDate}}. 
      <router-link to="/admin/billing" v-if="userHasReadPermission(PermissionTypes.AdminPermissionTypes.billing)">View Account</router-link>
    </NotificationBar>

    <NotificationBar v-if="accountActivatedWelcome" type="success">
      <NotificationBarTitle>Account Activated</NotificationBarTitle>
      Your account is now activated and ready to use.
    </NotificationBar>

    <DashboardAccountActivate
      v-if="isPendingAccountActivation"
      @accountUpdated="activateReloadAccountData"
    />

    <div v-if="!isPendingAccountActivation">
      
      <div class="mt-1" v-if="!isProfileDataLoaded">
        &nbsp;
        <Spinner />
      </div>

      <div v-if="isProfileDataLoaded">
        <AnalyticsDashboard type="home" />

      </div>
    </div>

  </div>
</template>

<script>
import SlimScroll from '@/components/slimScroll'
import DashboardContentBox from '@/components/dashboard/dashboardContentBox'
import UserNotificationList from '@/modules/core/components/userNotificationList'
import DashboardAccountActivate from '@/modules/core/components/dashboardAccountActivate.vue'
import DashboardGreetingBox from '@/modules/core/components/dashboardGreetingBox'
import DashboardAnalyticsBox from '@/modules/core/components/dashboardAnalyticsBox'

import PendingItemsList from '@/modules/core/components/pendingItemsList'

import AnalyticsDashboard from '@/modules/intelligence/components/analyticsDashboard'

import { mapState } from "vuex"

export default {
  name: "Dashboard",
  components: {
    SlimScroll,
    DashboardContentBox,

    UserNotificationList,
    PendingItemsList,
    DashboardAccountActivate,
    DashboardGreetingBox,
    DashboardAnalyticsBox,

    AnalyticsDashboard
  },
  data() {
    return {
      accountActivatedWelcome: false,
      notificationList: [],
      notificationLoading: false
    }
  },
  computed: {
    ...mapState({
      profileUser: state => state.profile.profileUser,
      profileCompanyName: state => state.profile.profileCompanyName,
      notificationUnreadRecentList: state => state.profile.notifications.recentUnreadList,
      isAccountLoaded: state => state.account.isAccountLoaded,
      isAccountInitialBillingSetup: state => state.account.isAccountInitialBillingSetup,
      isAccountActivated: state => state.account.isAccountActivated,
      hasActiveSubscription: state => state.account.hasActiveSubscription,
      isSubscriptionExpired: state => state.account.isSubscriptionExpired,
      isSubscriptionExpiringSoon: state => state.account.isSubscriptionExpiringSoon,
      subscriptionExpiryDate: state => state.account.subscriptionExpiryDate
    }),
    displaySubscriptionExpiryWarning() {
      // Only display 'expiry soon' warnings for subscriptions if the user has ability to view account info
      return !this.isSubscriptionExpired && this.isSubscriptionExpiringSoon && this.userHasReadPermission(this.PermissionTypes.AdminPermissionTypes.account)
    },
    isPendingAccountActivation() {
      return (!this.isAccountActivated && this.isAccountInitialBillingSetup && this.isAccountLoaded)
    },
    isProfileDataLoaded() {
      return this.profileUser && this.profileUser.id
    },
    userHasAnyIntelligencePermission() {
      let permissions = [
        this.PermissionTypes.IntelligencePermissionTypes.intelligenceInventory,
        this.PermissionTypes.IntelligencePermissionTypes.intelligenceOrder,
        this.PermissionTypes.IntelligencePermissionTypes.intelligenceProduction,
        this.PermissionTypes.IntelligencePermissionTypes.intelligenceAccount
      ]

      return permissions.some(permissionType => {      
        return this.userHasReadPermission(permissionType)
      })
    }
  },
  watch: {
    isAccountInitialBillingSetup: function() {
      // If initial billing not setup, jump straight to the account billing wizard
      if(!this.isAccountInitialBillingSetup && this.isAccountLoaded) {
        this.$router.push('/admin/tools/accountbilling')
      }      
    },
    isAccountActivated: function() {
      // If not an activated account, jump straight to the account activation/onboarding wizard
      if(!this.isAccountActivated && this.isAccountInitialBillingSetup && this.isAccountLoaded) {
        //this.$router.push('/admin/tools/accountactivate')
      }
    }
  },
  mounted() {
    // If not an activated account, jump straight to the account activation/onboarding wizard
    if(!this.isAccountActivated && this.isAccountInitialBillingSetup && this.isAccountLoaded) {
      //this.$router.push('/admin/tools/accountactivate')
    }
    // If initial billing not setup, jump straight to the account billing wizard
    if(!this.isAccountInitialBillingSetup && this.isAccountLoaded) {
      this.$router.push('/admin/tools/accountbilling')
    }
  },
  methods: {
    onClickNotification(notification) {
      // Flag notification as read
      // Don't wait for it to finish, just do it in the background
      this.$apiService.coreService.flagNotificationRead(notification.id)
      .then(response => {
        // Refresh profile with new unread counts
        this.$api.get("/profile").then(response => {
          this.$store.commit("profile/setProfile", response.data)
        })

        // V2: This will be done via socket.io system
      })

      this.$router.push(notification.link)
    },
    activateReloadAccountData() {
       // Re-request account data to check if account setup 
      this.$apiService.adminService.getAccount()
      .then(response => {
        this.$store.commit("account/setAccountData", response.data)

        // Account now activated? Display welcome
        if(this.isAccountActivated) {
          this.accountActivatedWelcome = true
        }
      })
      .catch(err => {
      })
    }
  }
}
</script>
